/**
 * Attributes for the editable area.
 *
 * @link https://www.w3.org/TR/wai-aria-1.2/#aria-roledescription
 * @link https://www.w3.org/TR/wai-aria-1.2/#aria-multiline
 *
 * @since 0.1.0
 */
export const ATTRIBUTES_EDITABLE_AREA = {
  autocorrect           : 'off',
  autocapitalize        : 'off',
  spellcheck            : 'false',
  role                  : 'textbox',
  'aria-multiline'      : true,
  'aria-roledescription': 'editor',
};
